export { Rating } from "./Rating";
export type { RatingProps } from "./Rating";
